export class PipelineEditorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PipelineEditorError';
  }
}
